import moment from 'moment';

import {USER_EDIT_DATE_FORMAT} from 'util/DateConstants';

export const DATE_DISPLAY_FORMAT = 'MMMM D, YYYY';

/**
 * Parse an ISO date string (YYYY-MM-DD) into a Date object.
 *
 * Returns null if the string is invalid, empty, or null.
 */
export function parseISODate(dateString: string | null): Date | null {
  if (dateString == null || dateString === '') {
    return null;
  }
  const parsed = moment(dateString, USER_EDIT_DATE_FORMAT, true);
  return parsed.isValid() ? parsed.toDate() : null;
}

/**
 * Format a Date object as an ISO date string (YYYY-MM-DD).
 */
export function formatToISODate(date: Date | null): string | null {
  if (date == null) {
    return null;
  }
  return moment(date).format(USER_EDIT_DATE_FORMAT);
}
